var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper",class:{hide: !_vm.modals.qrCode},on:{"click":function($event){$event.stopPropagation();return _vm.hideModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.value)?_c('QrcodeVue',{attrs:{"value":_vm.value,"size":_vm.size}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }